// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.getstarted_container_getstarted__bkUVW {
  width: 100%;
  margin-left: 0%;
  /* width: 100%; */
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column; 
}

.getstarted_container_thankyou__85F1b {
  width: 100%;
  margin-left: 0%;
  margin-bottom: 5%;
  /* width: 100%; */
  height: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  flex-direction: column; 
}

.getstarted_container_getstarted_body__n5pav {
  margin-left: 20%;
  align-items: flex-start;
  align-content: flex-start;
}

.getstarted_disabledCursor__IJvyq { 
  cursor: default;
}

.getstarted_bottom_right_buttons__37MIz {
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 0%;
  margin-left: 23%;
  margin-bottom: 1%;
}

.getstarted_input_getstarted_details__Ltt9g {
  width: 100%;
  border-radius: 15px;
  border: 0.5px solid; 
}

.getstarted_input_getstarted_email__iL2yZ {
  width: 100%;
  border-radius: 15px;
  border: 0.5px solid; 
}

.getstarted_home_icon__azH1E{
  margin-right: 5px;
  font-size: 20px !important;
}

navigation_close__1xDln, input[type="checkbox"] {
    display: inline;
}`, "",{"version":3,"sources":["webpack://./src/pages/GetStarted/getstarted.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".container_getstarted {\r\n  width: 100%;\r\n  margin-left: 0%;\r\n  /* width: 100%; */\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  flex-direction: column; \r\n}\r\n\r\n.container_thankyou {\r\n  width: 100%;\r\n  margin-left: 0%;\r\n  margin-bottom: 5%;\r\n  /* width: 100%; */\r\n  height: 100%;\r\n  display: flex;\r\n  align-items: center;\r\n  align-content: center;\r\n  justify-content: center;\r\n  flex-direction: column; \r\n}\r\n\r\n.container_getstarted_body {\r\n  margin-left: 20%;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n}\r\n\r\n.disabledCursor { \r\n  cursor: default;\r\n}\r\n\r\n.bottom_right_buttons {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  align-content: flex-end;\r\n  justify-content: flex-end;\r\n  flex-direction: row;\r\n  margin-top: 0%;\r\n  margin-left: 23%;\r\n  margin-bottom: 1%;\r\n}\r\n\r\n.input_getstarted_details {\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  border: 0.5px solid; \r\n}\r\n\r\n.input_getstarted_email {\r\n  width: 100%;\r\n  border-radius: 15px;\r\n  border: 0.5px solid; \r\n}\r\n\r\n.home_icon{\r\n  margin-right: 5px;\r\n  font-size: 20px !important;\r\n}\r\n\r\nnavigation_close__1xDln, input[type=\"checkbox\"] {\r\n    display: inline;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_getstarted": `getstarted_container_getstarted__bkUVW`,
	"container_thankyou": `getstarted_container_thankyou__85F1b`,
	"container_getstarted_body": `getstarted_container_getstarted_body__n5pav`,
	"disabledCursor": `getstarted_disabledCursor__IJvyq`,
	"bottom_right_buttons": `getstarted_bottom_right_buttons__37MIz`,
	"input_getstarted_details": `getstarted_input_getstarted_details__Ltt9g`,
	"input_getstarted_email": `getstarted_input_getstarted_email__iL2yZ`,
	"home_icon": `getstarted_home_icon__azH1E`
};
export default ___CSS_LOADER_EXPORT___;
